<template>
  <div>
    <h6>{{ question.label }} {{ question.required ? '*' : '' }}</h6>
    <div class="mb-2" v-html="question.description"></div>
    <b-form-group>
      <b-form-select
        :size="size"
        :name="question.slug"
        v-model="answer"
        :required="question.required"
        :state="!!errors ? false : null"
        :options="values"
        @change="$emit('clear-error', question.slug)"
      ></b-form-select>
      <b-form-invalid-feedback :state="!!errors ? false : null">
        {{ (errors||[]).join(' ') }}
      </b-form-invalid-feedback>
    </b-form-group>
  </div>
</template>

<script>
  export default {
    props: {
      value: String, // answer
      question: Object,
      disabled: {
        type: Boolean,
        default: false,
      },
      size: {
        type: String,
        default: 'md',
      },
      errors: Array,
    },
    data() {
      return {
        trans: trans,
        answer: this.value || this.question.options.default || null,
      }
    },
    computed: {
      values() {
        let values = (this.question.options.items || []).map(item => {
          return {value: item.value, text: item.value}
        })
        values.unshift({
          value: null,
          text: this.question.placeholder || ' ',
          disabled: this.question.required,
          selected: !this.answer
        })
        return values
      },
    },
    watch: {
      answer() {
        if (this.answer !== this.value)
          this.$emit('input', this.answer)
      },
      value() {
        this.answer = this.value || this.question.options.default || null
      },
      question() {
        this.answer = this.value || this.question.options.default || null
      },
    },
  }
</script>